module.exports = __webpack_public_path__ + "static/media/InstaWear.b0df7f18.jpg";